{
  "name": "aws-cdk",
  "description": "CDK Toolkit, the command line tool for CDK apps",
  "version": "2.111.0",
  "bin": {
    "cdk": "bin/cdk"
  },
  "scripts": {
    "build": "cdk-build",
    "watch": "cdk-watch",
    "lint": "cdk-lint",
    "pkglint": "pkglint -f",
    "test": "cdk-test",
    "integ": "jest --testMatch '**/?(*.)+(integtest).js'",
    "package": "cdk-package",
    "build+test+package": "yarn build+test && yarn package",
    "build+test": "yarn build && yarn test",
    "integ-cli": "npm run integ-cli-regression && npm run integ-cli-no-regression",
    "integ-cli-regression": "npm run integ-cli-regression-latest-release && npm run integ-cli-regression-latest-code",
    "integ-cli-regression-latest-release": "test/integ/run-against-dist test/integ/test-cli-regression-against-latest-release.sh",
    "integ-cli-regression-latest-code": "test/integ/run-against-dist test/integ/test-cli-regression-against-current-code.sh",
    "integ-cli-no-regression": "test/integ/run-against-repo test/integ/cli/test.sh",
    "integ-init": "test/integ/run-against-dist test/integ/init/test-all.sh",
    "gen": "./generate.sh",
    "build+extract": "yarn build",
    "build+test+extract": "yarn build+test",
    "attributions:update": "yarn node-bundle validate --entrypoint lib/index.ts --dont-attribute \"^@aws-cdk/|^cdk-assets|^cdk-cli-wrapper$\" --fix"
  },
  "cdk-build": {
    "post": [
      "cp ../../node_modules/cdk-from-cfn/index_bg.wasm ./lib/",
      "cp ../../node_modules/@aws-cdk/aws-service-spec/db.json.gz ./"
    ]
  },
  "cdk-package": {
    "bundle": {
      "externals": {
        "optionalDependencies": [
          "fsevents"
        ]
      },
      "allowedLicenses": [
        "Apache-2.0",
        "MIT",
        "BSD-3-Clause",
        "ISC",
        "BSD-2-Clause",
        "0BSD",
        "MIT OR Apache-2.0"
      ],
      "dontAttribute": "^@aws-cdk/|^@cdklabs/|^cdk-assets$|^cdk-cli-wrapper$",
      "test": "bin/cdk --version",
      "entryPoints": [
        "lib/index.js"
      ],
      "sourcemap": "linked",
      "minifyWhitespace": true
    }
  },
  "author": {
    "name": "Amazon Web Services",
    "url": "https://aws.amazon.com",
    "organization": true
  },
  "license": "Apache-2.0",
  "devDependencies": {
    "@aws-cdk/cdk-build-tools": "2.111.0-alpha.0",
    "@aws-cdk/pkglint": "2.111.0-alpha.0",
    "@octokit/rest": "^18.12.0",
    "@types/archiver": "^5.3.4",
    "@types/fs-extra": "^9.0.13",
    "@types/glob": "^7.2.0",
    "@types/jest": "^29.5.8",
    "@types/mockery": "^1.4.33",
    "@types/promptly": "^3.0.5",
    "@types/semver": "^7.5.5",
    "@types/sinon": "^9.0.11",
    "@types/source-map-support": "^0.5.10",
    "@types/table": "^6.0.0",
    "@types/uuid": "^8.3.4",
    "@types/wrap-ansi": "^3.0.0",
    "@types/yargs": "^15.0.18",
    "aws-cdk-lib": "2.111.0",
    "aws-sdk-mock": "5.6.0",
    "axios": "^1.6.0",
    "constructs": "^10.0.0",
    "fast-check": "^3.13.2",
    "jest": "^29.7.0",
    "jest-mock": "^29.7.0",
    "madge": "^5.0.2",
    "make-runnable": "^1.4.1",
    "nock": "^13.3.8",
    "sinon": "^9.2.4",
    "ts-jest": "^29.1.1",
    "ts-mock-imports": "^1.3.8",
    "xml-js": "^1.6.11"
  },
  "dependencies": {
    "@aws-cdk/cloud-assembly-schema": "2.111.0",
    "@aws-cdk/cloudformation-diff": "2.111.0",
    "@aws-cdk/cx-api": "2.111.0",
    "@aws-cdk/region-info": "2.111.0",
    "@jsii/check-node": "1.91.0",
    "archiver": "^5.3.2",
    "aws-sdk": "^2.1492.0",
    "camelcase": "^6.3.0",
    "cdk-assets": "2.111.0",
    "cdk-from-cfn": "^0.67.0",
    "chalk": "^4",
    "chokidar": "^3.5.3",
    "decamelize": "^5.0.1",
    "fs-extra": "^9.1.0",
    "glob": "^7.2.3",
    "json-diff": "^0.10.0",
    "minimatch": "^9.0.3",
    "promptly": "^3.2.0",
    "proxy-agent": "^6.3.1",
    "semver": "^7.5.4",
    "source-map-support": "^0.5.21",
    "strip-ansi": "^6.0.1",
    "table": "^6.8.1",
    "uuid": "^8.3.2",
    "wrap-ansi": "^7.0.0",
    "yaml": "1.10.2",
    "yargs": "^16.2.0"
  },
  "repository": {
    "url": "https://github.com/aws/aws-cdk.git",
    "type": "git",
    "directory": "packages/aws-cdk"
  },
  "keywords": [
    "aws",
    "cdk"
  ],
  "homepage": "https://github.com/aws/aws-cdk",
  "engines": {
    "node": ">= 14.15.0"
  },
  "nozem": {
    "ostools": [
      "git",
      "date",
      "cat",
      "dotnet",
      "mvn",
      "npm"
    ],
    "env": {
      "CODEBUILD_RESOLVED_SOURCE_VERSION": "|nzm-build"
    }
  },
  "stability": "stable",
  "maturity": "stable",
  "publishConfig": {
    "tag": "latest"
  }
}